module.exports = __webpack_public_path__ + "static/img/404.d3379df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404/404.svg
// module id = 757
// module chunks = 2 3 4 5 45